import { Component } from "react";

// Components
import AsyncRitualButton from "../global/AsyncRitualButton";
import DiscountButtonCopy from "./DiscountButtonCopy";

export default class DiscountButton extends Component {
  render() {
    const {
      className,
      promotion,
      prefix,
      price,
      showDash = true,
      allowCurrencyPostfix,
      showPricing = true,
      discountPrice,
    } = this.props;

    return (
      <AsyncRitualButton {...this.props} className={className}>
        <DiscountButtonCopy
          prefix={prefix}
          price={price}
          promotion={promotion}
          showDash={showDash}
          allowCurrencyPostfix={allowCurrencyPostfix}
          showPricing={showPricing}
          discountPrice={discountPrice}
        />
      </AsyncRitualButton>
    );
  }
}
